(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["battery-quick-order"] && !Shopify.designMode) return;
  try {
    

function bqCompareRows(a,b,key,direction){
  if(key==='name'){
    const av=a.querySelector('.bq-name').textContent.trim();
    const bv=b.querySelector('.bq-name').textContent.trim();
    return direction*av.localeCompare(bv,document.documentElement.lang||undefined,{sensitivity:'base',numeric:true})||Number(a.dataset.bqOriginal)-Number(b.dataset.bqOriginal);
  }
  const field=key==='stock'?'sortStock':'sortPrice';
  const av=a.dataset[field],bv=b.dataset[field];
  const am=av===''||av===undefined||!Number.isFinite(Number(av));
  const bm=bv===''||bv===undefined||!Number.isFinite(Number(bv));
  if(am!==bm)return am?1:-1;
  return (am?0:direction*(Number(av)-Number(bv)))||Number(a.dataset.bqOriginal)-Number(b.dataset.bqOriginal);
}
document.addEventListener('click',function(event){
  const button=event.target.closest('[data-bq-sort],[data-bq-reset-sort]');
  if(!button||button.disabled)return;
  const root=button.closest('.bq');
  if(root.dataset.busy==='true')return;
  const tbody=root.querySelector('.bq-table tbody');
  if(!tbody)return;
  const rows=Array.from(tbody.querySelectorAll('[data-bq-row]'));
  rows.forEach((row,index)=>{if(row.dataset.bqOriginal===undefined)row.dataset.bqOriginal=String(index);});
  const key=button.dataset.bqSort;
  const direction=key&&root.dataset.sortKey===key&&root.dataset.sortDirection==='1'?-1:1;
  rows.sort(key?(a,b)=>bqCompareRows(a,b,key,direction):(a,b)=>Number(a.dataset.bqOriginal)-Number(b.dataset.bqOriginal));
  const fragment=document.createDocumentFragment();
  rows.forEach(row=>fragment.appendChild(row));
  tbody.prepend(fragment);
  root.dataset.sortKey=key||'';
  root.dataset.sortDirection=key?String(direction):'';
  root.querySelectorAll('[data-bq-sort]').forEach(control=>{
    const active=control.dataset.bqSort===key;
    control.closest('th').setAttribute('aria-sort',active?(direction===1?'ascending':'descending'):'none');
    control.querySelector('[data-bq-sort-arrow]').textContent=active?(direction===1?'↑':'↓'):'↕';
  });
});

function bqSelection(root){
  return Array.from(root.querySelectorAll('[data-bq-qty]')).map(input=>({input,id:Number(input.dataset.variant),quantity:Math.max(0,Math.min(Number(input.max)||0,Math.floor(Number(input.value)||0)))}));
}
function bqRefresh(root){
  const units=bqSelection(root).reduce((sum,row)=>sum+row.quantity,0);
  root.querySelector('[data-bq-count]').textContent=units;
  root.querySelector('[data-bq-add-button]').disabled=root.dataset.bqReady!=='true'||units===0||root.dataset.busy==='true';
}
document.addEventListener('input',function(event){
  if(!event.target.matches('[data-bq-qty]'))return;
  const root=event.target.closest('.bq');
  bqSelection(root).forEach(row=>{if(row.input===event.target)row.input.value=row.quantity;});
  bqRefresh(root);
});
document.addEventListener('click',async function(event){
  const button=event.target.closest('[data-bq-add-button]');
  if(!button)return;
  const root=button.closest('.bq');
  if(root.dataset.bqReady!=='true'||root.dataset.busy==='true')return;
  const rows=bqSelection(root).filter(row=>row.quantity>0);
  if(!rows.length)return;
  root.dataset.busy='true';
  bqRefresh(root);
  const status=root.querySelector('[data-bq-status]');
  status.textContent='';
  root.querySelectorAll('[data-bq-qty]').forEach(input=>{input.dataset.wasDisabled=String(input.disabled);input.disabled=true;});
  try{
    const response=await fetch(root.dataset.bqAdd,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:rows.map(row=>({id:row.id,quantity:row.quantity}))})});
    const result=await response.json();
    if(!response.ok||!Array.isArray(result.items))throw new Error('cart');
    const matches=rows.every(row=>result.items.some(item=>Number(item.variant_id)===row.id&&Number(item.price)===Number(row.input.dataset.price)));
    if(!matches)throw new Error('price');
    rows.forEach(row=>{row.input.max=Math.max(0,Number(row.input.max)-row.quantity);row.input.value=0;});
    status.textContent=root.dataset.bqSuccess;
    root.querySelectorAll('[data-bq-qty]').forEach(input=>{input.disabled=input.dataset.wasDisabled==='true'||Number(input.max)===0;});
  }catch(error){
    status.textContent=root.dataset.bqError;
    root.dataset.bqReady='false';
    root.querySelectorAll('button[name="checkout"]').forEach(input=>{input.disabled=true;});
  }finally{
    root.dataset.busy='false';
    bqRefresh(root);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-installation-browser"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bo-installation-browser')){
class InstallationBrowser extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.items=[];this.industry='all';this.loaded=false;this.dialog=this.querySelector('dialog');this.openButton=this.querySelector('.bib-open');this.status=this.querySelector('.bib-status');this.results=this.querySelector('.bib-results');this.search=this.querySelector('input');this.retry=this.querySelector('.bib-retry');this.warning=this.querySelector('.bib-warning');this.openButton.hidden=false;this.openButton.addEventListener('click',()=>{this.dialog.showModal();this.search.focus();if(!this.loaded)this.load();});this.querySelector('.bib-close').addEventListener('click',()=>this.dialog.close());this.dialog.addEventListener('close',()=>this.openButton.focus());this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});this.search.addEventListener('input',()=>this.render());this.querySelectorAll('[data-industry]').forEach(b=>b.addEventListener('click',()=>{this.industry=b.dataset.industry;this.querySelectorAll('[data-industry]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));this.render();}));this.retry.addEventListener('click',()=>this.load());this.load();}
 normalize(value){return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}
 async getDocument(path){const url=new URL(path,location.origin);if(url.origin!==location.origin)throw Error('External page');const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);const control=new AbortController();const timeout=setTimeout(()=>control.abort(),12000);try{const response=await fetch(url.href,{credentials:'same-origin',signal:control.signal});if(!response.ok)throw Error('Page unavailable');return new DOMParser().parseFromString(await response.text(),'text/html');}finally{clearTimeout(timeout);}}
 async load(){if(this.loading)return;this.loading=true;this.loaded=false;this.retry.hidden=true;this.warning.hidden=true;this.results.replaceChildren();this.status.textContent=this.dataset.loading;try{const directory=await this.getDocument(this.dataset.directory);const seen=new Set();const links=[...directory.querySelectorAll('template[data-bo-installation-link]')].map(n=>({...n.dataset})).filter(n=>{try{const u=new URL(n.url,location.origin);if(u.origin!==location.origin||seen.has(u.pathname))return false;seen.add(u.pathname);return true;}catch{return false;}});let index=0,failures=0;const found=[];const worker=async()=>{while(index<links.length){const order=index++;const link=links[order];try{const doc=await this.getDocument(link.url);const entry=doc.querySelector('template[data-bo-installation]');if(!entry)throw Error('Missing installation data');const data={...entry.dataset};if(data.schematic!=='true'||!(data.products||'').split('|').includes(this.dataset.product))continue;found.push({...data,industry:link.industry,industryLabel:link.industryLabel,url:link.url,order});}catch{failures++;}}};await Promise.all(Array.from({length:Math.min(3,links.length)},worker));this.items=found.sort((a,b)=>a.order-b.order);this.loaded=true;this.hidden=this.items.length===0;this.render();if(failures){this.warning.textContent=this.dataset.partial;this.warning.hidden=false;this.retry.hidden=false;}}catch{this.items=[];this.hidden=true;this.status.textContent=this.dataset.error;this.retry.hidden=false;}finally{this.loading=false;}}
 render(){if(!this.loaded)return;const terms=this.normalize(this.search.value).trim().split(/\s+/).filter(Boolean);const items=this.items.filter(item=>(this.industry==='all'||item.industry===this.industry)&&terms.every(term=>this.normalize([item.title,item.summary,item.industryLabel,item.battery,item.charging].join(' ')).includes(term)));this.results.replaceChildren();this.status.textContent=items.length?this.dataset.count.replace('[count]',items.length):(this.items.length?this.dataset.empty:this.dataset.none);for(const item of items){const card=document.createElement('a');card.className='bib-card';card.href=item.url;let image;try{const u=new URL(item.image,location.origin);if(item.image&&u.protocol==='https:'){image=document.createElement('img');image.src=u.href;image.alt='';image.loading='lazy';}}catch{}if(!image)image=document.createElement('div');image.className='bib-thumb';card.append(image);const body=document.createElement('div');const label=document.createElement('span');label.className='bib-industry';label.textContent=item.industryLabel;const title=document.createElement('h3');title.textContent=item.title;const summary=document.createElement('p');summary.textContent=item.summary;const tags=document.createElement('div');tags.className='bib-tags';for(const text of [item.battery,item.charging,item.schematic==='true'?this.dataset.free:''].filter(Boolean)){const tag=document.createElement('span');tag.textContent=text;tags.append(tag);}const cta=document.createElement('span');cta.className='bib-cta';cta.textContent=this.dataset.view+' →';body.append(label,title,summary,tags,cta);card.append(body);this.results.append(card);}}
}
customElements.define('bo-installation-browser',InstallationBrowser);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schematic-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bo-schematic-directory')) {
    customElements.define('bo-schematic-directory', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.searchTimer);
        if (this.controller) this.controller.abort();
      }

      initialize() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.controls = this.querySelector('[data-controls]');
        this.searchInput = this.querySelector('[data-search-input]');
        this.typeSelect = this.querySelector('[data-system-select]');
        this.voltageSelect = this.querySelector('[data-voltage-select]');
        this.empty = this.querySelector('[data-empty]');
        this.counter = this.querySelector('[data-count]');
        this.resetButton = this.querySelector('[data-reset]');
        this.pills = [...this.querySelectorAll('[data-industry]')];
        this.categories = [...this.querySelectorAll('[data-category]')];
        if (!this.controls || !this.searchInput || !this.typeSelect) return;
        this.typeLabel = this.typeSelect.options[0].textContent;
        this.cards = [...this.querySelectorAll('[data-card]')].map(element => ({
          element,
          industry: element.dataset.cardIndustry,
          system: element.dataset.system,
          label: element.dataset.systemLabel,
          voltage: element.dataset.voltage,
          search: this.normalize(element.dataset.search)
        }));
        this.state = this.readURL();
        this.render();
        this.controls.hidden = false;

        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const category = event.target.closest('[data-category]');
          const pill = event.target.closest('[data-industry]');
          const reset = event.target.closest('[data-reset]');
          if (category && this.contains(category)) {
            // Preserve normal browser behavior for modified link clicks.
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            clearTimeout(this.searchTimer);
            this.state = { industry: category.dataset.category, system: 'all', voltage: 'all', query: '' };
            this.render();
            this.writeURL('push');
            this.querySelector('.bsd__results').scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'start'
            });
          } else if (pill && this.contains(pill)) {
            this.state.industry = pill.dataset.industry;
            this.state.system = 'all';
            this.render();
            this.writeURL('push');
          } else if (reset && this.contains(reset)) {
            clearTimeout(this.searchTimer);
            this.state = { industry: 'all', system: 'all', voltage: 'all', query: '' };
            this.render();
            this.writeURL('push');
            this.searchInput.focus({ preventScroll: true });
          }
        }, { signal });

        this.searchInput.addEventListener('input', () => {
          clearTimeout(this.searchTimer);
          this.state.query = this.searchInput.value;
          this.render();
          this.searchTimer = setTimeout(() => {
            this.writeURL('replace');
          }, 150);
        }, { signal });

        this.typeSelect.addEventListener('change', () => {
          this.state.system = this.typeSelect.value;
          this.render();
          this.writeURL('push');
        }, { signal });

        this.voltageSelect.addEventListener('change', () => {
          this.state.voltage = this.voltageSelect.value;
          this.render();
          this.writeURL('push');
        }, { signal });

        window.addEventListener('popstate', () => {
          clearTimeout(this.searchTimer);
          this.state = this.readURL();
          this.render();
        }, { signal });

        document.addEventListener('shopify:block:select', event => {
          if (!this.cards.some(card => card.element.dataset.blockId === event.detail.blockId)) return;
          clearTimeout(this.searchTimer);
          this.state = { industry: 'all', system: 'all', voltage: 'all', query: '' };
          this.render();
        }, { signal });
      }

      normalize(value) {
        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      }

      readURL() {
        const params = new URL(window.location.href).searchParams;
        const industry = (params.get('industry') || 'all').toLowerCase();
        const voltage = (params.get('voltage') || 'all').toLowerCase().replace(/\s/g, '');
        const rawSystem = params.get('system') || 'all';
        return {
          industry: ['all', 'marine', 'solar', 'residential', 'automotive'].includes(industry) ? industry : 'all',
          system: this.cards.some(card => card.system === rawSystem) ? rawSystem : 'all',
          voltage: ['all', '12v', '24v', '48v', 'other'].includes(voltage) ? voltage : 'all',
          query: params.get('query') || ''
        };
      }

      writeURL(mode) {
        // Keep Shopify preview parameters, language paths, and unrelated parameters intact.
        if (window.Shopify && window.Shopify.designMode) return;
        const url = new URL(window.location.href);
        for (const key of ['industry', 'system', 'voltage', 'query']) {
          const value = this.state[key];
          if (!value || value === 'all') url.searchParams.delete(key);
          else url.searchParams.set(key, value);
        }
        if (url.href !== window.location.href) {
          try { window.history[mode === 'push' ? 'pushState' : 'replaceState'](window.history.state, '', url); }
          catch (_) { /* Browsing and filtering still work if URL updates are restricted. */ }
        }
      }

      render() {
        const availableTypes = new Map();
        this.cards.forEach(card => {
          if ((this.state.industry === 'all' || card.industry === this.state.industry) && card.system && card.label) {
            availableTypes.set(card.system, card.label);
          }
        });
        if (!availableTypes.has(this.state.system)) this.state.system = 'all';
        this.typeSelect.replaceChildren(new Option(this.typeLabel, 'all'));
        [...availableTypes.entries()].sort((a, b) => a[1].localeCompare(b[1])).forEach(([value, label]) => {
          this.typeSelect.add(new Option(label, value));
        });
        this.typeSelect.value = this.state.system;
        this.voltageSelect.value = this.state.voltage;
        if (this.searchInput.value !== this.state.query) this.searchInput.value = this.state.query;
        const words = this.normalize(this.state.query).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        this.cards.forEach(card => {
          const matches = (this.state.industry === 'all' || card.industry === this.state.industry)
            && (this.state.system === 'all' || card.system === this.state.system)
            && (this.state.voltage === 'all' || card.voltage === this.state.voltage)
            && words.every(word => card.search.includes(word));
          card.element.hidden = !matches;
          if (matches) count += 1;
        });
        this.pills.forEach(pill => {
          const active = pill.dataset.industry === this.state.industry;
          pill.classList.toggle('is-active', active);
          pill.setAttribute('aria-pressed', String(active));
        });
        this.categories.forEach(category => {
          const active = category.dataset.category === this.state.industry;
          category.classList.toggle('is-active', active);
          if (active) category.setAttribute('aria-current', 'true');
          else category.removeAttribute('aria-current');
          const url = new URL(window.location.href);
          for (const key of ['system', 'voltage', 'query']) url.searchParams.delete(key);
          url.searchParams.set('industry', category.dataset.category);
          url.hash = this.querySelector('.bsd__results').id;
          category.href = url.pathname + url.search + url.hash;
        });
        this.counter.textContent = count + ' ' + (count === 1 ? this.dataset.countOne : this.dataset.countMany);
        this.empty.hidden = count > 0;
        this.resetButton.hidden = this.state.industry === 'all' && this.state.system === 'all'
          && this.state.voltage === 'all' && !this.state.query;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schematic-request"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bo-schematic-request')) {
    customElements.define('bo-schematic-request', class extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
      disconnectedCallback() { cancelAnimationFrame(this.frame); if (this.events) this.events.abort(); }
      initialize() {
        this.i18n = JSON.parse(this.querySelector("[data-bo-i18n]").textContent);
        if (this.events) this.events.abort();
        this.events = new AbortController();
        const signal = this.events.signal;
        this.form = this.querySelector('[data-request-form]');
        this.submitButton = this.querySelector('[data-submit]');
        this.originalButton = this.submitButton.innerHTML;
        this.ready = this.dataset.ready === 'true';
        this.editor = this.dataset.editor === 'true' || !!(window.Shopify && window.Shopify.designMode);
        this.sending = false;
        this.status = this.querySelector('[data-submit-status]');
        this.uploads = [...this.querySelectorAll('[data-upload]')];
        this.syncConditionalFields();
        this.validateUploads();

        this.form.addEventListener('change', () => { this.syncConditionalFields(); this.validateUploads(); }, { signal });
        this.form.addEventListener('input', event => {
          if (event.target instanceof HTMLInputElement && (event.target.closest('[data-other-application]') || event.target.closest('[data-other-ac]') || event.target.closest('[data-other-dc]'))) event.target.setCustomValidity('');
        }, { signal });

        // Use a native multipart POST: preserve file bytes and provider verification.
        // Do not disable named inputs or clear the form before the browser sends it.
        this.form.addEventListener('submit', event => {
          if (!this.ready || this.editor || this.sending) { event.preventDefault(); event.stopPropagation(); return; }
          this.syncConditionalFields();
          const validUploads = this.validateUploads();
          [this.querySelector('[data-other-application] input'), this.querySelector('[data-other-ac] input'), this.querySelector('[data-other-dc] input')].forEach(input => {
            input.setCustomValidity(input.required && !input.value.trim() ? this.i18n.please_describe_this_option : '');
          });
          if (!validUploads || !this.form.checkValidity()) { event.preventDefault(); event.stopPropagation(); this.form.reportValidity(); return; }
          let endpoint;
          try { endpoint = new URL(this.form.action); } catch (_) {}
          if (!endpoint || endpoint.origin !== 'https://formsubmit.co' || !/^\/[A-Za-z0-9@._+\-]+$/.test(endpoint.pathname) || endpoint.search || endpoint.hash) {
            event.preventDefault(); event.stopPropagation();
            this.status.textContent = this.i18n.this_request_form_is_not_available_please_use_the_conta;
            this.status.hidden = false;
            return;
          }
          event.stopPropagation();
          this.sending = true;
          this.submitButton.disabled = true;
          this.submitButton.textContent = this.i18n.opening_secure_submission;
          this.status.textContent = this.i18n.complete_the_verification_on_the_next_screen_to_send_yo;
          this.status.hidden = false;
        }, { capture:true, signal });

        window.addEventListener('pageshow', event => {
          if (!event.persisted) return;
          const wasSending = this.sending;
          this.sending = false;
          this.submitButton.innerHTML = this.originalButton;
          this.submitButton.disabled = !this.ready || this.editor;
          this.syncConditionalFields();
          this.validateUploads();
          if (wasSending) {
            this.status.textContent = this.i18n.if_you_completed_the_confirmation_your_request_may_alre;
            this.status.hidden = false;
          }
        }, { signal });
      }
      syncConditionalFields() {
        const application = [...this.form.querySelectorAll('input[name="Application"]')].find(input => input.checked);
        const ac = this.form.querySelector('[data-ac-voltage]');
        const dc = this.form.querySelector('[data-dc-voltage]');
        [
          [this.querySelector('[data-other-application]'), application && application.value === 'Other'],
          [this.querySelector('[data-other-ac]'), ac.value === 'Other'],
          [this.querySelector('[data-other-dc]'), dc.value === 'Other']
        ].forEach(([container, show]) => {
          const input = container.querySelector('input');
          container.hidden = !show;
          input.disabled = !show;
          input.required = !!show;
          input.setCustomValidity('');
        });
      }
      validateUploads() {
        let total = 0;
        let count = 0;
        let message = '';
        let invalidInput = null;
        this.uploads.forEach(input => {
          input.setCustomValidity('');
          [...input.files].forEach(file => {
            count++;
            total += file.size;
            if (!message && !/\.(jpe?g|png|gif|webp|heic|heif|pdf)$/i.test(file.name)) {
              message = this.i18n.choose_a_jpg_png_gif_webp_heic_heif_or_pdf_file;
              invalidInput = input;
            }
          });
        });
        // Decimal MB keeps the full selection at or below the documented limit.
        if (!message && total > 10000000) {
          message = this.i18n.your_attachments_total_more_than_10_mb_choose_smaller_f;
          invalidInput = this.uploads.find(input => input.files.length);
        }
        if (invalidInput) invalidInput.setCustomValidity(message);
        const error = this.querySelector('[data-upload-error]');
        error.textContent = message;
        error.hidden = !message;
        this.querySelector('[data-upload-summary]').textContent = count ? count + (count === 1 ? this.i18n.file_selected : this.i18n.files_selected) + (total / 1000000).toFixed(1) + this.i18n.mb_total : '';
        return !message;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["system-case-study"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bo-system-case-study')) {
    customElements.define('bo-system-case-study', class extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        if (this.viewer && this.viewer.open) this.viewer.close();
      }

      initialize() {
        this.i18n = JSON.parse(this.querySelector("[data-bo-i18n]").textContent);
        if (this.events) this.events.abort();
        this.events = new AbortController();
        const signal = this.events.signal;
        this.index = 0;
        this.busy = false;
        this.uncertain = false;
        this.completed = false;
        this.editor = this.dataset.editor === 'true' || !!(window.Shopify && window.Shopify.designMode);
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.thumbnails = [...this.querySelectorAll('[data-thumbnail]')];
        this.viewer = this.querySelector('[data-viewer]');
        this.viewerImage = this.querySelector('[data-viewer-image]');
        this.viewerScroll = this.querySelector('[data-viewer-scroll]');
        this.rows = [...this.querySelectorAll('[data-product-form]')].map(element => {
          let breaks = [];
          try { breaks = JSON.parse(element.dataset.priceBreaks || '[]'); } catch (_) {}
          return {
            element, id: element.dataset.variantId, title: element.dataset.title,
            price: Number(element.dataset.price), breaks,
            stock: element.dataset.stock === '' ? null : Number(element.dataset.stock),
            buyable: element.dataset.purchasable === 'true',
            input: element.querySelector('[data-quantity]'),
            button: element.querySelector('[data-add-one]'),
            error: element.querySelector('[data-row-error]')
          };
        });
        this.addSystem = this.querySelector('[data-add-system]');
        this.status = this.querySelector('[data-cart-status]');
        this.notice = this.querySelector('[data-package-notice]');
        this.subtotal = this.querySelector('[data-subtotal]');
        try { this.money = new Intl.NumberFormat(this.dataset.locale || 'en', { style:'currency', currency:this.dataset.currency || 'USD' }); }
        catch (_) { this.money = new Intl.NumberFormat('en', { style:'currency', currency:'USD' }); }
        this.querySelectorAll('[data-js-only]').forEach(el => { el.hidden = false; });
        this.selectImage(0);
        this.updateProducts();

        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const target = event.target;
          const thumbnail = target.closest('[data-thumbnail]');
          const imageLink = target.closest('[data-open-image]');
          const quantityButton = target.closest('[data-quantity-change]');
          const zoomButton = target.closest('[data-zoom]');
          if (thumbnail) this.selectImage(Number(thumbnail.dataset.thumbnail));
          else if (target.closest('[data-gallery-prev]')) this.selectImage(this.index - 1);
          else if (target.closest('[data-gallery-next]')) this.selectImage(this.index + 1);
          else if (target.closest('[data-enlarge-current]') && this.slides.length) {
            const slide = this.slides[this.index];
            this.openViewer(slide.dataset.full, slide.dataset.alt, target.closest('button'));
          } else if (imageLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
            if (this.viewer && typeof this.viewer.showModal === 'function') {
              event.preventDefault();
              this.openViewer(imageLink.href, imageLink.dataset.imageAlt, imageLink);
            }
          } else if (target.closest('[data-close-viewer]')) this.viewer.close();
          else if (zoomButton) this.setZoom(zoomButton.dataset.zoom);
          else if (quantityButton && !this.busy && !this.uncertain && !this.completed) {
            const row = this.rows.find(row => row.element.contains(quantityButton));
            if (row && row.buyable) {
              if (quantityButton.dataset.quantityChange === '1') row.input.stepUp();
              else row.input.stepDown();
              this.updateProducts();
            }
          } else if (target.closest('[data-add-system]')) this.addToCart(this.rows);
        }, { signal });

        // Capture our submit events before a theme's generic AJAX form handlers.
        this.addEventListener('submit', event => {
          const row = this.rows.find(row => row.element === event.target);
          if (!row) return;
          event.preventDefault();
          event.stopPropagation();
          this.addToCart([row]);
        }, { capture:true, signal });

        this.addEventListener('input', event => {
          if (event.target instanceof Element && event.target.matches('[data-quantity]')) this.updateProducts();
        }, { signal });

        this.addEventListener('keydown', event => {
          if (!(event.target instanceof Element) || !event.target.closest('[data-thumbnail]')) return;
          const changes = { ArrowLeft:this.index - 1, ArrowRight:this.index + 1, Home:0, End:this.slides.length - 1 };
          if (!(event.key in changes)) return;
          event.preventDefault();
          this.selectImage(changes[event.key]);
          this.thumbnails[this.index].focus({ preventScroll:true });
        }, { signal });

        const stage = this.querySelector('[data-gallery-stage]');
        if (stage) {
          stage.addEventListener('pointerdown', event => {
            this.touchStart = event.pointerType === 'touch' ? { x:event.clientX, y:event.clientY } : null;
          }, { passive:true, signal });
          stage.addEventListener('pointercancel', () => { this.touchStart = null; }, { signal });
          stage.addEventListener('pointerup', event => {
            if (!this.touchStart) return;
            const dx = event.clientX - this.touchStart.x;
            const dy = event.clientY - this.touchStart.y;
            this.touchStart = null;
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.selectImage(this.index + (dx < 0 ? 1 : -1));
          }, { passive:true, signal });
        }

        if (this.viewer) {
          this.viewer.addEventListener('close', () => { if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll:true }); }, { signal });
          this.viewer.addEventListener('click', event => {
            if (event.target !== this.viewer) return;
            const bounds = this.viewer.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.viewer.close();
          }, { signal });
        }
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.selectImage(index);
        }, { signal });
        window.addEventListener('pageshow', event => {
          if (event.persisted && this.completed) {
            this.completed = false;
            this.message(this.i18n.your_previous_selection_was_added_view_your_cart_before);
            this.updateProducts();
          }
        }, { signal });
      }

      selectImage(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.thumbnails.forEach((button, i) => {
          button.classList.toggle('is-active', i === this.index);
          button.setAttribute('aria-pressed', String(i === this.index));
        });
        const count = this.querySelector('[data-image-count]');
        const caption = this.querySelector('[data-gallery-caption]');
        if (count) count.textContent = (this.index + 1) + ' / ' + this.slides.length;
        if (caption) caption.textContent = this.slides[this.index].dataset.caption || '';
        const active = this.thumbnails[this.index];
        if (active) {
          const rail = active.parentElement;
          if (active.offsetLeft < rail.scrollLeft) rail.scrollLeft = active.offsetLeft;
          else if (active.offsetLeft + active.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = active.offsetLeft + active.offsetWidth - rail.clientWidth;
        }
      }

      openViewer(source, alt, opener) {
        if (!this.viewer || typeof this.viewer.showModal !== 'function') { window.open(source, '_blank', 'noopener'); return; }
        this.opener = opener;
        this.viewerImage.src = source;
        this.viewerImage.alt = alt || this.i18n.installation_image;
        this.querySelector('[data-viewer-title]').textContent = alt || this.i18n.image_viewer;
        this.querySelector('[data-original-link]').href = source;
        this.zoom = 1;
        this.setZoom('reset');
        if (!this.viewer.open) this.viewer.showModal();
        this.querySelector('[data-close-viewer]').focus();
      }

      setZoom(action) {
        this.zoom = action === 'reset' ? 1 : Math.min(4, Math.max(1, (this.zoom || 1) + (action === 'in' ? .5 : -.5)));
        this.viewerImage.style.width = (this.zoom * 100) + '%';
        this.querySelector('[data-zoom-label]').textContent = Math.round(this.zoom * 100) + '%';
        if (action === 'reset') { this.viewerScroll.scrollLeft = 0; this.viewerScroll.scrollTop = 0; }
      }

      rowQuantity(row) { return Number(row.input.value); }
      quantityError(row, quantity) {
        const min = Number(row.input.min) || 1;
        const step = Number(row.input.step) || 1;
        const max = row.input.max === '' ? null : Number(row.input.max);
        if (!Number.isSafeInteger(quantity) || quantity < min || (quantity - min) % step !== 0) return this.i18n.use_a_whole_quantity_of_at_least + min + this.i18n.in_steps_of + step + '.';
        if (max !== null && quantity > max) return this.i18n.the_maximum_order_quantity_for_this_item_is + max + '.';
        if (row.stock !== null && quantity > row.stock) return this.i18n.this_quantity_is_not_currently_available;
        return '';
      }

      updateProducts() {
        const locked = this.busy || this.uncertain || this.completed || this.editor;
        const grouped = new Map();
        this.rows.forEach(row => {
          if (row.id) grouped.set(row.id, (grouped.get(row.id) || 0) + this.rowQuantity(row));
        });
        let total = 0;
        let complete = this.rows.length > 0;
        let priceKnown = this.rows.length > 0;
        this.rows.forEach(row => {
          const quantity = this.rowQuantity(row);
          const error = row.buyable ? this.quantityError(row, quantity) : '';
          row.input.disabled = !row.buyable || locked;
          row.input.setAttribute('aria-invalid', String(Boolean(error)));
          row.error.textContent = error;
          row.error.hidden = !error;
          row.button.disabled = !row.buyable || Boolean(error) || locked;
          row.element.querySelectorAll('[data-quantity-change]').forEach(button => { button.disabled = !row.buyable || locked; });
          if (!row.buyable || error) complete = false;
          if (!row.id || !Number.isFinite(row.price) || !Number.isSafeInteger(quantity) || quantity < 1) priceKnown = false;
          let price = row.price;
          [...row.breaks].sort((a,b) => a.minimum - b.minimum).forEach(tier => { if ((grouped.get(row.id) || 0) >= tier.minimum && Number.isFinite(tier.price)) price = tier.price; });
          if (row.id) row.element.querySelector('[data-unit-price]').textContent = this.money.format(price / 100);
          total += price * quantity;
        });
        this.addSystem.disabled = !complete || locked;
        this.addSystem.textContent = this.busy ? this.i18n.adding : this.completed ? this.i18n.added_to_cart : this.i18n.add_system_to_cart;
        this.subtotal.textContent = priceKnown && Number.isFinite(total) ? this.money.format(total / 100) : '—';
        this.notice.hidden = complete && !this.editor && !this.uncertain;
        if (this.editor) this.notice.textContent = this.i18n.use_storefront_preview_to_test_cart_buttons;
        else if (this.uncertain) this.notice.textContent = this.i18n.review_your_cart_before_adding_again;
        else if (!complete) this.notice.textContent = this.i18n.the_full_package_is_not_currently_available_in_these_qu;
      }

      message(text, isError = false) {
        this.status.textContent = text;
        this.status.classList.toggle('is-error', isError);
      }

      async requestJSON(url, options = {}) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(url, { credentials:'same-origin', cache:'no-store', ...options, signal:controller.signal });
          let data;
          try { data = await response.json(); } catch (_) { throw new Error(this.i18n.unexpected_cart_response); }
          if (!response.ok || Number(data.status) >= 400) {
            const detail = typeof data.description === 'string' ? data.description : this.i18n.the_cart_could_not_accept_this_request;
            throw new Error(detail);
          }
          return data;
        } finally { clearTimeout(timer); }
      }

      async addToCart(rows) {
        if (this.busy || this.uncertain || this.completed || this.editor || !rows.length) return;
        const grouped = new Map();
        for (const row of rows) {
          const quantity = this.rowQuantity(row);
          const error = this.quantityError(row, quantity);
          if (!row.buyable || !/^\d+$/.test(row.id || '') || error) {
            this.message(error || this.i18n.one_of_the_listed_items_is_unavailable, true);
            this.updateProducts();
            return;
          }
          const previous = grouped.get(row.id);
          if (previous) previous.quantity += quantity;
          else grouped.set(row.id, { id:row.id, quantity, row });
        }
        this.busy = true;
        this.message(this.i18n.checking_your_cart);
        this.updateProducts();
        let addAttempted = false;
        try {
          const cart = await this.requestJSON(this.dataset.cartUrl + '.js');
          if (!Array.isArray(cart.items)) throw new Error(this.i18n.unable_to_read_your_cart_please_try_again);
          if (!this.isConnected) return;
          for (const item of grouped.values()) {
            if (!Number.isSafeInteger(item.quantity)) throw new Error(this.i18n.please_use_a_smaller_quantity);
            const inCart = cart.items.filter(line => String(line.variant_id || line.id) === item.id).reduce((sum, line) => sum + Number(line.quantity || 0), 0);
            const combined = inCart + item.quantity;
            const limit = item.row.input.max === '' ? null : Number(item.row.input.max);
            if (limit !== null && combined > limit) throw new Error(item.row.title + this.i18n.the_requested_quantity_plus_your_cart_exceeds_this_item);
            if (item.row.stock !== null && combined > item.row.stock) throw new Error(item.row.title + this.i18n.this_quantity_is_not_available_when_combined_with_the_i);
          }
          this.message(this.i18n.adding_the_selected_equipment);
          addAttempted = true;
          const result = await this.requestJSON(this.dataset.addUrl, {
            method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
            body:JSON.stringify({ items:[...grouped.values()].map(({ id, quantity }) => ({ id, quantity })) })
          });
          if (!Array.isArray(result.items)) throw new Error(this.i18n.the_cart_addition_could_not_be_confirmed);
          const returnedIds = new Set(result.items.map(item => String(item.variant_id || item.id)));
          if ([...grouped.keys()].some(id => !returnedIds.has(id))) throw new Error(this.i18n.the_complete_selection_could_not_be_confirmed);
          this.completed = true;
          this.message(this.i18n.added_opening_your_cart);
          // A full cart navigation keeps older themes' cart counts and contents in sync.
          if (this.isConnected) window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (!this.isConnected) return;
          if (addAttempted) {
            // Shopify can partially add stock even when returning 422. Never retry automatically.
            this.uncertain = true;
            this.message(this.i18n.we_could_not_confirm_the_full_addition_some_items_may_a, true);
          } else {
            this.message(error.name === 'AbortError' ? this.i18n.the_cart_check_timed_out_please_try_again : error.message, true);
          }
        } finally {
          this.busy = false;
          if (this.isConnected) this.updateProducts();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template--cart"]) return;
  try {
    
function initBatteryCart(){document.querySelectorAll('.boc:not([data-enhanced])').forEach(root=>{root.dataset.enhanced='true';root.addEventListener('click',event=>{const button=event.target.closest('[data-boc-step]');if(!button)return;const input=button.parentElement.querySelector('input');const step=Number(input.step)||1;input.value=Math.max(0,(Number(input.value)||0)+Number(button.dataset.bocStep)*step);input.dispatchEvent(new Event('change',{bubbles:true}));});root.addEventListener('change',event=>{if(event.target.name!=='updates[]')return;const status=root.querySelector('[data-boc-status]');status.textContent=status.dataset.message;});});}
initBatteryCart();document.addEventListener('shopify:section:load',initBatteryCart);

  } catch(e) { console.error(e); }
})();
})();
